import qs from "qs";
import moment from "moment";
import {
  AUTH_COMPLETED,
  AUTH_ERROR_MODAL_CLOSED,
  AUTH_FAILED,
  IS_BASIC_LOGIN_ALLOWED,
  NETWORK_REQUEST_SENT,
  SELF_PHOTO,
  SET_SSO_AUTH_STATE,
  SIGNED_OUT,
  SSO_IS_NOT_IMPLEMENTED,
} from "./types";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import i18n from '../i18n';


// Порог в минутах: обновляем токен, когда до истечения осталось меньше этого времени.
// Токен живёт 60 минут (valid: 3600), поэтому значение должно быть заметно меньше 60.
const TOKEN_UPDATING_INTERVAL = 5;

// Куда уходить после успешного входа: на страницу, с которой PrivateRoute увёл
// гостя на логин (history.location.state.from), иначе — в личный кабинет.
const getAfterAuthPath = (history) => {
  const from = history.location.state?.from;
  return from ? `${from.pathname}${from.search || ""}` : "/lk";
};

const getTimeToExpireToken = (getState) => {
  const { expires } = getState().auth;
  // expires приходит в GMT (напр. "Mon, 06 Jul 2026 11:07:48 GMT") и корректно
  // парсится moment'ом как UTC. Сравниваем абсолютные инстанты в UTC и получаем
  // остаток жизни токена в минутах.
  return moment.utc(expires).diff(moment.utc()) / 1000 / 60;
};

export const checkAndUpdateToken = () => async (dispatch, getState) => {
  const timeToExpire = getTimeToExpireToken(getState);
  if (timeToExpire < TOKEN_UPDATING_INTERVAL) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/token`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const result = await response.json();
      if (result.error && result.error.message === "Unauthorized") {
        dispatch({ type: SIGNED_OUT });
      } else {
        dispatch({ type: AUTH_COMPLETED, user: result });
      }
    }
  }
};

export const signOut = (history) => async (dispatch, getState) => {
  dispatch({ type: SELF_PHOTO, payload: '' });
  await dispatch({ type: SIGNED_OUT });
  const state = getState();
  
  const devMode = window.location.hostname === 'localhost'

  if (state.layout.data?.logoutaction && !devMode) {
    window.location.href = state.layout.data.logoutaction;
  } else {
    history.push("/");
  }
};

export const auth = (values, history) => async (dispatch, getState) => {
  // const { username, password } = values;
  // const tok = `${username.trim()}:${password.trim()}`;
  // const hash = btoa(unescape(encodeURIComponent(tok)));
  // const Authorization = `Basic ${hash}`;
  let params = {};
  if (values.username && values.password) {
    params = {
      username: values.username.trim(),
      password: values.password.trim(),
    };
  } else if (values.rfid_token) {
    params = { rfid_token: values.rfid_token };
  }
  const response = await fetch(`${BACKEND_URL_PREFIX}${getState().auth.url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
    // body: JSON.stringify({ "rfid_token": '600C408A88752F' }),

    body: JSON.stringify(params),
  });
  dispatch({ type: NETWORK_REQUEST_SENT, response });
  if (response.ok) {
    const result = await response.json();
    const {code, message} = result.error || {}
    if (code === 401) {
      const error = message.includes('login and password')
        ? "Неверное имя пользователя или пароль"
        : message.includes('не имеет статус')
          ? "Данный пользователь не имеет статус 'Текущий' в переменном составе"
          : message.includes('rfid')
            ? "Карта ПЭК не найдена в системе. Авторизация невозможна"
            : message
      dispatch({type: AUTH_FAILED, error});
    } else {
      dispatch({ type: AUTH_COMPLETED, user: result });
      // eslint-disable-next-line
      history.location.pathname === "/" && history.push(getAfterAuthPath(history));
    }
  } else if (response.status === 401) {
    dispatch({
      type: AUTH_FAILED,
      error: "Неверное имя пользователя или пароль",
    });
  }
};

export const allowBasicLogin = () => async (dispatch) => {
  const response = await fetch(`${BACKEND_URL_PREFIX}/settings`);

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const result = await response.json();
    dispatch({
      type: IS_BASIC_LOGIN_ALLOWED,
      allowBasicLogin: result.auth.sso.allowbasiclogin,
    });
  }
};

// TODO после активации sso поправить.
export const sso = (history) => async (dispatch, getState) => {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/token/sso`,
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
      },
    }
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  const parameters = qs.parse(history.location.search.substring(1));

  const { login, password, win } = parameters;
  const loginAndPasswordExist = login && password;

  if (win) {
    const response = await fetch(`${BACKEND_URL_PREFIX}/token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify({
        rfid_token: win,
      }),
    });

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: AUTH_COMPLETED, user: result });
      history.push(getAfterAuthPath(history));
    }

    return;
  }

  if (response.ok) {
    const result = await response.json();
    dispatch({ type: AUTH_COMPLETED, user: result });
    dispatch({ type: SET_SSO_AUTH_STATE, payload: true });
    // eslint-disable-next-line
    history.push(getAfterAuthPath(history));
  } else if (response.status === 404) {
    dispatch({ type: SSO_IS_NOT_IMPLEMENTED });
    dispatch({ type: SET_SSO_AUTH_STATE, payload: false });
    if (getState().auth.token) {
      if (loginAndPasswordExist) {
        dispatch(signOut(history));
        dispatch(auth({ username: login, password }, history));
      }
      if (getTimeToExpireToken(getState) <= 0) {
        dispatch(signOut(history));
      } else {
        dispatch(checkAndUpdateToken());
        history.location.pathname === "/" && history.push(getAfterAuthPath(history));
      }
    } else {
      loginAndPasswordExist
        ? dispatch(auth({ username: login, password }, history))
        : history.push("/", history.location.state);
    }
  } else if (response.status === 401) {
    dispatch({ type: SET_SSO_AUTH_STATE, payload: false });
    // dispatch(allowBasicLogin());
    history.push("/", history.location.state);
  } else {
    dispatch({ type: SET_SSO_AUTH_STATE, payload: false });
    console.log("sso error");
    history.push("/", history.location.state);
  }
};

export const getLocalizeWords = (lang = 'en') => async (dispatch, getState) => {
  const response = await fetch(`${BACKEND_URL_PREFIX}/localization`,
    buildDefaultHeaders(getState)
  );
  const translations = await response.json();
  i18n.addResourceBundle(lang, 'translation', translations, true, true);
  i18n.changeLanguage(lang);
};

export const closeAuthError = () => ({ type: AUTH_ERROR_MODAL_CLOSED });
